import type { ButtonProps } from '@chakra-ui/react'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { LuX } from 'react-icons/lu'

import { IconButton } from './icon-button'

export type CloseButtonProps = ButtonProps

export const CloseButton = React.forwardRef<
  HTMLButtonElement,
  CloseButtonProps
>((props, ref) => {
  const { t } = useTranslation()
  return (
    <IconButton
      variant="ghost"
      aria-label={t('global:close')}
      ref={ref}
      {...props}
    >
      {props.children ?? <LuX />}
    </IconButton>
  )
})
